"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var _str$split, _str$split$map;

  var str = _ref.str,
      _ref$split = _ref.split,
      split = _ref$split === void 0 ? [','] : _ref$split;
  return (str === null || str === void 0 ? void 0 : (_str$split = str.split(new RegExp("[".concat(split.join(''), "]"), 'g'))) === null || _str$split === void 0 ? void 0 : (_str$split$map = _str$split.map(function (x) {
    return x === null || x === void 0 ? void 0 : x.trim();
  })) === null || _str$split$map === void 0 ? void 0 : _str$split$map.filter(Boolean)) || [];
};

exports["default"] = _default;